import { initializeApp } from "firebase/app"
import { getAnalytics } from "firebase/analytics"
import firebase from "firebase/app"
import { getMessaging } from "firebase/messaging"

// const vapidKey = "BJCMAMtTFQgFa6kHgdKnUYQ7WgBIzZ99LnNgQExEXHKIUYNfmKmfUpg0js1FSd39LnrI4ce-SWx0dYeaZrSSuFY"
// const firebaseConfig = {
// 	apiKey: "AIzaSyB6nFBjOMX8uxa_QjI0wgw_AfMN2GTaRUg",
// 	authDomain: "notif-app-6814e.firebaseapp.com",
// 	projectId: "notif-app-6814e",
// 	storageBucket: "notif-app-6814e.appspot.com",
// 	messagingSenderId: "686312635639",
// 	appId: "1:686312635639:web:5efe69fdbdc3f1f90967f2",
// 	measurementId: "G-3W0M60Z73J"
// }

const vapidKey = "BKyeH-_zBDHxdnHcZwtB4XlMqxRf4RFiFVwm7w0pmpxwQvv-Jhg3l62ZshfDRyW8U7f9YfyY6V-2YALQz1GLeME"
const firebaseConfig = {
	apiKey: "AIzaSyDoNtbXa-JwPYJCi8WierRwxG5UfIMb95E",
	authDomain: "wmsaffa-notif.firebaseapp.com",
	projectId: "wmsaffa-notif",
	storageBucket: "wmsaffa-notif.appspot.com",
	messagingSenderId: "13984672972",
	appId: "1:13984672972:web:2e6b333b5c03c87f902669",
	measurementId: "G-ESKTHVVB6M"
}

const app = initializeApp(firebaseConfig)

const messaging = getMessaging(app)

export { messaging, vapidKey }
